"use strict";function flatten(t){return Buffer.from(t).toString()}Object.defineProperty(exports,"__esModule",{value:!0}),exports.flatten=flatten;